import classNames from 'classnames'
import { motion } from 'framer-motion'
import { ReactNode } from 'react'

import { useMenuStore } from '@apps-common/stores/menuStore'

interface IProps {
  id?: string
  children: ReactNode
  padTop?: boolean
  bgClasses?: string
  overlayClasses?: string
}

export const PageContentContainerNoSidebar: React.FC<IProps> = ({ id, children, padTop = false, bgClasses, overlayClasses }) => {
  const { open } = useMenuStore()

  return (
    <motion.div
      id={id}
      initial={false}
      animate={{
        opacity: open ? 0.9 : 1,
        transition: { ease: 'easeInOut', duration: 0.3 }
      }}
      className={classNames(
        bgClasses,
        'w-[calc(100%-100px)] relative bg-primary text-primary-content overflow-y-auto scrollbar-none',
        padTop && 'top-padding'
      )}
    >
      {children}
    </motion.div>
  )
}
